import { createStore, combineReducers, applyMiddleware } from "redux"
import logger from "redux-logger"
import thunk from "redux-thunk"
import * as reducers from "./reducers/index"

export default () => {
  return createStore(combineReducers(reducers), applyMiddleware(logger, thunk))
}
